<div class="chart" echarts [options]="options"></div>
<div class="legend">
  <span><b class="hi"></b>{{ 'dashboard.legend.billable' | translate }}</span>
  <span><b class="lo"></b>{{ 'dashboard.legend.less' | translate }}</span>
</div>
